import React from 'react';
import { Body2 } from '../../../typography';
import { Highlighted } from './styled';
export const Title = ({ title, isSingle }) => {
    if (typeof title === 'function') {
        const CustomTitle = title;
        return React.createElement(CustomTitle, null);
    }
    if (typeof title === 'string' && title.length > 0) {
        return React.createElement(Body2, null, title);
    }
    return (React.createElement(Body2, null,
        "Drop them here or ",
        React.createElement(Highlighted, null, `Choose file${!isSingle ? 's' : ''}`)));
};
